import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-ac-vat-code-data',
  templateUrl: './ac-vat-code-data.component.html',
  styleUrls: ['./ac-vat-code-data.component.css']
})
export class AcVatCodeDataComponent implements OnInit {
    acVatCodeKeyno;

    acVatCodeDataKeyno;

    public edit?: Edit;

    public selectListVatReportGroups: VatReportGroupItem[] = [];

    public selectListVatTaxLevels: VatTaxLevelItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.acVatCodeKeyno = this.stateService.getStateParams()['acvatcode_keyno'];
        this.acVatCodeDataKeyno = this.stateService.getStateParams()['acvatcodedata_keyno'];
    }

    private async loadEdit() {
        if (!!this.acVatCodeKeyno && !!this.acVatCodeDataKeyno) {
            this.edit = (await this.datatask.Post(3427, {
                acvatcode_keyno: this.acVatCodeKeyno,
                acvatcodedata_keyno: this.acVatCodeDataKeyno
            }))[0];
        }
    }

    private async loadVatReportGroups(): Promise<void> {
        this.selectListVatReportGroups = await this.datatask.Post(3434);
    }

    private async loadVatTaxLevels(): Promise<void> {
        this.selectListVatTaxLevels = await this.datatask.Post(3433);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3428, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadVatReportGroups();
        this.loadVatTaxLevels();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    acvatcodedata_keyno: number;
    acvatcode_keyno: number;
    acvatcode_name: string;
    account_no: number;
    amountformula: string;
    baseformula: string;
    settlementaccount_vat: string;
    saft_maincode: string;
    saft_spectext: string;
    saft_show_base: string;
    vatreportgroup_keyno: string;
    vattaxlevel_keyno: string;
}

interface VatReportGroupItem {
    vatreportgroup_keyno: number;
    vatreportgroup_name: string;
    orderby: number;
}

interface VatTaxLevelItem {
    vattaxlevel_keyno: number;
    vattaxlevel_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acVatCodeData', {
//        templateUrl: 'views/components/views/acVatCodeData/acVatCodeData.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'acVatCodeDataService', function ($stateParams, stateService, translateService, modalService, acVatCodeDataService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acVatCodeKeyno = $stateParams.acvatcode_keyno;
//            let acVatCodeDataKeyno = $stateParams.acvatcodedata_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                vatReportGroupsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vatreportgroup_keyno = '0' }
//                ],
//                vatTaxLevelsButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.vattaxlevel_keyno = '0' }
//                ],
//                edit: {},
//                selectListVatReportGroups: [],
//                selectListVatTaxLevels: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await acVatCodeDataService.getEdit({
//                    acvatcode_keyno: acVatCodeKeyno,
//                    acvatcodedata_keyno: acVatCodeDataKeyno
//                }))[0];
//            }

//            async function loadVatReportGroups() {
//                vm.model.selectListVatReportGroups = await acVatCodeDataService.listVatReportGroups();
//            }

//            async function loadVatTaxLevels() {
//                vm.model.selectListVatTaxLevels = await acVatCodeDataService.listVatTaxLevels();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                acVatCodeDataService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadVatReportGroups();
//                loadVatTaxLevels();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
